import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M12 9.675a2.325 2.325 0 1 0 0 4.65 2.325 2.325 0 0 0 0-4.65ZM8.175 12a3.825 3.825 0 1 1 7.65 0 3.825 3.825 0 0 1-7.65 0Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m12.825 3.25.807 1.2a2.5 2.5 0 0 0 2.553 1.057l1.419-.277 1.166 1.166-.277 1.419a2.5 2.5 0 0 0 1.058 2.553l1.199.807v1.65l-1.2.807a2.5 2.5 0 0 0-1.057 2.553l.277 1.419-1.166 1.166-1.419-.277a2.5 2.5 0 0 0-2.553 1.058l-.807 1.199h-1.65l-.807-1.2a2.5 2.5 0 0 0-2.553-1.057l-1.42.277-1.165-1.166.277-1.419a2.5 2.5 0 0 0-1.058-2.553l-1.199-.807v-1.65l1.2-.807a2.5 2.5 0 0 0 1.057-2.553L5.23 6.396 6.396 5.23l1.419.277a2.5 2.5 0 0 0 2.553-1.058l.807-1.199h1.65Zm1.096-1.058a1 1 0 0 0-.83-.442h-2.182a1 1 0 0 0-.83.442l-.955 1.42a1 1 0 0 1-1.022.423l-1.68-.329a1 1 0 0 0-.899.275L3.981 5.524a1 1 0 0 0-.275.898l.329 1.68a1 1 0 0 1-.423 1.022l-1.42.955a1 1 0 0 0-.442.83v2.182a1 1 0 0 0 .442.83l1.42.955a1 1 0 0 1 .423 1.022l-.329 1.68a1 1 0 0 0 .275.899l1.542 1.542a1 1 0 0 0 .9.275l1.68-.329a1 1 0 0 1 1.02.423l.957 1.42a1 1 0 0 0 .83.442h2.18a1 1 0 0 0 .83-.442l.956-1.42a1 1 0 0 1 1.022-.423l1.68.329a1 1 0 0 0 .899-.275l1.542-1.542a1 1 0 0 0 .275-.9l-.329-1.68a1 1 0 0 1 .423-1.02l1.42-.957a1 1 0 0 0 .442-.83v-2.18a1 1 0 0 0-.442-.83l-1.42-.956a1 1 0 0 1-.423-1.022l.329-1.68a1 1 0 0 0-.275-.898L18.477 3.98a1 1 0 0 0-.9-.275l-1.68.329a1 1 0 0 1-1.02-.423l-.957-1.42Z"
    />
  </svg>
);
export default SvgTwoColorSettings;
